import React from 'react';

/**
 * Visible AEO callout - used on hub pages so Perplexity / ChatGPT / Google AI
 * can extract the answer from the rendered HTML, not just JSON-LD.
 */
export const AeoCallout = ({ q, a, testId }) => (
    <aside
        className="border border-brand-hairline border-l-2 border-l-brand-gold bg-brand-surface p-5 md:p-6"
        data-testid={testId || 'aeo-callout'}
    >
        <span className="font-display text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold">
            {q}
        </span>
        <p className="mt-3 font-sans text-base leading-relaxed text-brand-text">
            {a}
        </p>
    </aside>
);

export default AeoCallout;
